// Treechat's cut of an ordinal sale, taken out of the seller's proceeds. The
// server rounds down to whole sats (Ordinals::MarketFee); mirror it exactly so
// the number a seller reads is the number the settlement pays.
const DEFAULT_MARKET_FEE_BPS = 1_500
const MAX_MARKET_FEE_BPS = 9_999

function configuredBps(): unknown {
    try {
        const activeGon =
            typeof window !== 'undefined' ? window.gon : typeof gon !== 'undefined' ? gon : null
        return activeGon?.ORDINAL_MARKET_FEE_BPS
    } catch {
        return undefined
    }
}

export function marketFeeBps(): number {
    const configured = configuredBps()
    return typeof configured === 'number' && Number.isSafeInteger(configured)
        ? Math.max(1, Math.min(configured, MAX_MARKET_FEE_BPS))
        : DEFAULT_MARKET_FEE_BPS
}

export function marketFeeSats(priceSats: number): number {
    if (!Number.isSafeInteger(priceSats) || priceSats <= 1) return 0
    return Math.min(priceSats - 1, Math.max(1, Math.floor((priceSats * marketFeeBps()) / 10_000)))
}

export function marketSellerProceedsSats(priceSats: number): number {
    return priceSats - marketFeeSats(priceSats)
}

export function marketFeePercentLabel(): string {
    const percent = marketFeeBps() / 100
    return `${Number.isInteger(percent) ? percent : parseFloat(percent.toFixed(2))}%`
}
